import { Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronLeft } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useGetApi } from "../../../../../../hooks";
import { type IHistoryItem } from "../../../../../../interfaces";
import { useDispatch, useSelector } from "../../../../../../redux/hooks";
import { Flex, StyledTable, StyledTh } from "../../../../../../styled";
import { Button } from "../../../../../shared/Button/Button";
import Loader from "../../../../../shared/Loader/Loader";
import { getMedIdType } from "../utils/getMedIdType";
import ModalGenerator from "./ModalGenerator";
import ModalItem from "./ModalItem";
import { setModalProps } from "../../../../../../redux/slices/medicalHistorySlice";

const MedicalHistoryModal = () => {
  const [opened, { open, close }] = useDisclosure();
  const { userid } = useParams();
  const dispatch = useDispatch();
  const { modalProps } = useSelector(state => state.medicalHistory);
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const { data, refetch, isLoading } = useGetApi<{ list: IHistoryItem[] }>({
    request: "get-med-row-history",
    body: {
      params: {
        userid,
        section: modalProps?.section,
        ...(modalProps?.id
          ? { [getMedIdType(modalProps?.section)]: modalProps?.id }
          : { archived: true }),
      },
    },
    fetchOnInit: false,
  });
  useEffect(() => {
    if (modalProps) {
      void refetch();
      open();
    }
  }, [modalProps, open, refetch]);
  const handleClose = () => {
    dispatch(setModalProps(null));
    setSelectedRow(null);
    close();
  };
  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      size="90%"
      title={`History ${!modalProps?.id ? "of archived rows" : "of row"}`}>
      {isLoading && <Loader />}
      {selectedRow ? (
        <div>
          <Button
            leftIcon={<IconChevronLeft />}
            onClick={() => setSelectedRow(null)}>
            Go back
          </Button>
          <ModalGenerator dataKey={modalProps?.section} row={selectedRow} />
        </div>
      ) : data && data?.list?.length > 0 ? (
        <StyledTable>
          <thead>
            <StyledTh>Action</StyledTh>
            <StyledTh>Date</StyledTh>
            <StyledTh>Rank</StyledTh>
            <StyledTh>Name</StyledTh>
            {!modalProps?.id && <StyledTh>View</StyledTh>}
          </thead>
          {data.list?.map((el, i) => (
            <ModalItem key={el.hid} {...el} setSelectedRow={setSelectedRow} />
          ))}
        </StyledTable>
      ) : (
        <Text align="center">No history data</Text>
      )}
    </Modal>
  );
};
export default MedicalHistoryModal;
